// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2492":"951c4605","4407":"d4c879a3","5877":"951c4605","6533":"5fccd88b","8127":"d4c879a3","8133":"ef911346","9958":"951c4605","9975":"d4c879a3"}[chunkId] + ".chunk.css";
};